import { ref } from 'vue'
import { db, collection, query, getDocs, orderBy } from '../firebase/config'

const getPosts = () => {
  const myData = ref([])
  const error = ref(null)

  const load = async (coll) => {
    try {
      const q = query(collection(db, '/schools/inspire-schools/' + coll), orderBy('createdAt', 'desc'))

      const querySnapshot = await getDocs(q)
      querySnapshot.forEach((doc) => {
        // console.log(doc.id, ' => ', doc.data())
        myData.value = querySnapshot.docs.map(doc => {
          return { ...doc.data(), id: doc.id }
        })
      })
    } catch (err) {
      error.value = err.message
    }
  }

  return { myData, error, load }
}

export default getPosts
